/**
 * iter 138 → iter 167 — Realtime event subscription.
 *
 * Original iter138 implementation opened a fresh EventSource per component.
 * iter167 refactored this to multiplex on a single SseProvider-owned
 * connection. This file is now a thin shim so every existing page that
 * imports `useRealtimeEvents` keeps working unchanged.
 */
import { useSseSubscribe } from '../context/SseContext';

export function useRealtimeEvents(handlers) {
  useSseSubscribe(handlers);
}
